import { useDispatch, useSelector } from "react-redux"
import data, { urlapi } from "../../lib/backend/data"
import { useEffect, useState } from "react"
import { cerrarSesion } from "../../redux/actions/sesion"
import { Button, Checkbox, Col, Form, Input, Pagination, Popconfirm, Row, Table, Tag, message } from "antd"
import CargandoTabla from "./cargando"
import Column from "antd/es/table/Column"
import Title from "antd/es/typography/Title"
import { fechaATextoSimple } from "../../lib/helpers/helpers"
import { SearchOutlined } from "@ant-design/icons"
import { encontrarLlaveValorEnEsquema } from "../../lib/helpers/interfaz"
import PersonalizarColumnas from "../../subComponents/interfaz/columnas_personalizar"
import EncabezadoPesonalizado from "../../subComponents/general/tablas/encabezado"
import { PiCursorClickFill } from 'react-icons/pi'
import ModalPersonalizado from "../../subComponents/general/modales/modal_personalizado"
import GraficosCamposPersonalizados from "../../subComponents/graficos/conductores"
import { obtenerFechaHoraZonaHorariaLocal } from "../../lib/helpers/dates"
import HelperModal from "../../subComponents/general/helperModal"
import { modulo, stringByStatus, tipos_disponibilidad } from "./data"
import TagSinDatos from "../../subComponents/general/tag_sin_datos"
import { IoCloseSharp } from "react-icons/io5"
import { FaCheckCircle, FaRegTrashAlt } from "react-icons/fa"
import { DateTime } from "luxon"
import VerSolicitudRapido from "./previsualizar"
import { stringByStatusSolicitud } from "../SolicitudesDisponibilidadesExternas/data"
import { MdCancel } from "react-icons/md"

const ListadoCanales = (props)=> {
    const {
        condicion_default,
        showCustomFieldsData,
        hideSearch,
        showFilters,
        showSelection,
        exclude,
        hideActions,
        componentAction,
        loadingActions,
        typeView,
        hideColumns,
        hideExcelButton
    } = props
    const dispatch = useDispatch()
    const sesion                    = useSelector(state => state.miusuario)
    const [conductores, setConductores] = useState([])
    const [deleting, setDeleting]   = useState(false)
    const [ loadingExcel, setLoadingExcel ] = useState(false)
    const [loadingConductores, setLoadingConductores] = useState([])
    const [messageApi, contextHolder] = message.useMessage();
    const [ pagina, setPagina ]     = useState(1)
    const [ campoBusqueda, setCampoBusqueda ] = useState('')
    const [ total, setTotal ]       = useState(0)
    const [ condicion_busqueda, setCondicionBusqueda ] = useState(condicion_default ? condicion_default : {})
    const pais                      = useSelector(state => state.pais)
    const session                   = useSelector(state => state.miusuario)
    const interfaz_usuario          = useSelector(state => state.interfaz)
    const idioma                    = useSelector(state => state.idioma)
    const trash                     = props.trash ? props.trash : false
    const tipo                      = props.tipo ? props.tipo : "link"
    const titulo                    = props.title ? props.title : 'registros'
    const [ filtroBusqueda, setFiltroBusqueda ] = useState({})
    const [ filtroBusquedaMetaData, setFiltroBusquedaMetaData ] = useState({})
    const key_interfaz              = 'tabla_canales'
    const key_esquema               = 'CANALES'
    const module                    = modulo
    const [ key_input_filter, setKeyInputFilter ] = useState(0)

    const descargarExcel = async () => {
        setLoadingExcel(true)
        return fetch(`${data.urlapi}/reports/${module}`,{
            method:'POST',
            body: JSON.stringify({
                condicion: condicion_busqueda
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${sesion.tokenSession}`,
                'country': pais,
                'lang': idioma
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.blob()
        })
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            const fecha = obtenerFechaHoraZonaHorariaLocal()
            a.download = `reporte-${fecha}.xlsx`;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();    
            a.remove();
            return setLoadingExcel(false)
        })
        .catch(error => {
            messageApi.error("Error al consultar la información, intente nuevamente")
            return setLoadingExcel(false)
        })
    }

    const obtenerRegistros = async (page, query)=>{
        setLoadingConductores(true)
        if(query) if(trash === true) query.status = 'trash'
        const condicion = query ? query : condicion_busqueda
        return fetch(`${urlapi}/${module}/list`,{
            method:'POST',
            body: JSON.stringify({
                condicion,
                pagina: page
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${sesion.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                messageApi.error('Sin datos')
                return setLoadingConductores(false)
            } else if(res.errorMessage){
                messageApi.error(res.errorMessage)
                return setLoadingConductores(false)
            }
            if(Array.isArray(res.datos) !== false){
                setConductores(res.datos)
                setTotal(res.total)
            }
            return setLoadingConductores(false)
        })
        .catch(error => {
            messageApi.error("Error al consultar la información, intente nuevamente")
            return setLoadingConductores(false)
        })
    }

    const eliminarRecurso = async (id) => {
        setDeleting(true)
        return fetch(`${urlapi}/${module}?id=${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer: ${sesion.tokenSession}`,
            'country': pais,
            'lang': idioma
          },
        })
          .then((res) => {
            if (res.status === 401) return dispatch(cerrarSesion());
            return res.json();
          })
          .then(async (res) => {
            if (!res) {
                messageApi.error("Sin datos obtenidos")
            } else if (res.errorMessage) {
                messageApi.error(res.errorMessage)
            } else if(res._id){
              messageApi.success("Eliminado exitosamente")
              obtenerRegistros(1, false)
            }
            return setDeleting(false)
          })
          .catch((error) => {
            messageApi.error("Error al consultar la información, intente nuevamente")
            return setDeleting(false)
          })
      }
  

    useEffect(() => {
        obtenerRegistros(1, condicion_default)
    }, [ condicion_default ])

    const handleChangePagina = (e) => {
        setPagina(e)
        obtenerRegistros(e, condicion_busqueda)
    }

    const paginacion = (ciclo, total) => {
        const cantidad = Math.ceil(total / ciclo)
        if(!cantidad) return false
        return <div className="mb-3">
            <Title level={5} className="mt-0" >TOTAL <b style={{ fontWeight: "bold" }}>{total}</b></Title>
            <Pagination showSizeChanger={false} defaultCurrent={pagina} total={(cantidad*10)} onChange={handleChangePagina} />
        </div>
    }

    const deseleccionarTodos = (e) => {
        setConductores([...[], ...conductores.map(veh => { 
            if(exclude){
                if( Array.isArray(exclude) !== false ){
                    if(exclude.includes(veh._id)) return veh
                }
            }
            veh.seleccionado = e.target.checked
            return veh 
        })])
      }

      const checkForEnabledValue = (id) => {
        if(exclude){
            if( Array.isArray(exclude) !== false ){
                if(exclude.includes(id)) return true
            }
        }
        return false
      }

      const handleChangeSeleccion = (e) => {
        const { name } = e.target
        const valor = e.target.checked
        const i = conductores.findIndex(ve => ve._id === name )
        conductores[i].seleccionado = valor
        setConductores([...[], ...conductores])
      }

      const validarChecked = (seleccionado, id) => {
        if(seleccionado === true) return true
        if(exclude){
            if( Array.isArray(exclude) !== false ){
                if(exclude.includes(id)) return true
            }
        }
        return false
      }

    const seleccionarRegistro = (data, action) => {
        deseleccionarTodos({ target: false })
        let datos = data
        if(Array.isArray(datos) !== true) datos = [data]
        if(props.onSelect) props.onSelect(datos, action)
    }

    const seleccionarEspecial = (action) => {
        return seleccionarRegistro(conductores.filter(veh => veh.seleccionado === true), action)
      }

      const accionButtons = () => {
        if(showSelection !== true) return false
        const seleccionados = conductores.filter(veh => veh.seleccionado === true).length
        const enable = seleccionados > 0 ? false : true

        if(componentAction){
            return <div style={{ marginTop: 10, marginBottom: 10 }} onClick={() => seleccionarRegistro(conductores.filter(veh => veh.seleccionado === true))}>
                {componentAction.map(it => {
                    return <Button disabled={enable} loading={ loadingActions === true } size="small" style={{ marginRight: 10 }} onClick={() => seleccionarEspecial(it.label)} >{it.label}</Button>
                })}
            </div>
        }

        return <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Row gutter={15}>
                <Col span="auto"><Button disabled={enable} size="small" onClick={() => seleccionarRegistro(conductores.filter(veh => veh.seleccionado === true))}>SELECCIONAR</Button></Col>
                <Col span="auto"><Title level={5} className="mt-0 mb-0"><PiCursorClickFill /> Toca el título para seleccionar uno</Title></Col>
            </Row>
        </div>
      }

      const showByType = (tipo, data) => {
        switch (tipo) {
            case "funcion":
                return <b className="hover" onClick={() => seleccionarRegistro(data)}>{data.titulo ? data.titulo : 'SIN INFORMACIÓN'}</b>
            default:
                return data.titulo
        }
    }

    const mostrarRegistros = () => {
        if(loadingConductores) return <CargandoTabla />

        const component_estado = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="status" />} render={(data) => {
            return <div>{stringByStatusSolicitud(data.status)}</div>
        }} />

        const component_titulo = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="titulo" />} render={(data) => {
            return <div>{showByType(typeView, data)}</div>
        }} />
        const component_orden = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="orden" />} render={(data) => {
            return <div>{data.orden?.internal_id ? data.orden?.internal_id : <TagSinDatos /> }</div>
        }} />
        const component_empresa = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="empresa" />} render={(data) => {
            return <div>{data.empresa?.razon_social}</div>
        }} />

        const component_asignar_app = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="asignar_app" />} render={(data) => {
            return <div>{data.asignar_app === true ? <FaCheckCircle /> : <MdCancel /> }</div>
        }} />
        const component_crear_ruta = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="crear_ruta" />} render={(data) => {
            return <div>{data.crear_ruta === true ? <FaCheckCircle /> : <MdCancel /> }</div>
        }} />

        const component_creador = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="creador" />} render={(data) => {
            return <div>{data.creador?.nombres} {data.creador?.apellidos}</div>
        }} />
        const component_fecha = <Column title={<EncabezadoPesonalizado key_esquema={key_esquema} key_interfaz={key_interfaz} slug="createdAt" />} render={(data) => {
            return <div>{fechaATextoSimple(data.createdAt)}</div>
        }} />

        const acciones_botones = <Column title="Acciones" fixed="right" ellipsis render={(data) => {
            return <div>
                <Row gutter={15}>
                    <Col span="auto"><VerSolicitudRapido id_registro={data._id} onCreate={() => obtenerRegistros(1, false)} /></Col>
                    <Col span="auto">
                    <Popconfirm
            title="Eliminar"
            description="¿Estás seguro que deseas eliminar recurso? Esta acción no se puede deshacer"
            onConfirm={() => eliminarRecurso(data._id)}
            onCancel={() => false}
            okText="SI"
            style={{ display: "inline-block" }}
            cancelText="NO"
          >
          <Button loading={deleting} size="small" className="m-0" type="dashed" danger>ELIMINAR</Button>
          </Popconfirm>
                    </Col>
                </Row>
                
          </div>
        }} />

        return <div>
            {paginacion(data.pagina, total)}
            {accionButtons()}
            <Table dataSource={conductores} pagination={false} size="small"  bordered locale={{ emptyText: <HelperModal tipo="disponibilidades" /> }} >
            {
            showSelection !== true ? false : <Column title={<Checkbox onChange={deseleccionarTodos} />} render={(data) => {
                return <Checkbox disabled={checkForEnabledValue(data._id)} checked={validarChecked(data.seleccionado, data._id)} name={data._id} onChange={handleChangeSeleccion}/>
            }} />
            }
                { encontrarLlaveValorEnEsquema("titulo", interfaz_usuario[ key_interfaz ]) === false ? false : component_titulo }
                { encontrarLlaveValorEnEsquema("status", interfaz_usuario[ key_interfaz ]) === false ? false : component_estado }
                { encontrarLlaveValorEnEsquema("asignar_app", interfaz_usuario[ key_interfaz ]) === false ? false : component_asignar_app }
                { encontrarLlaveValorEnEsquema("crear_ruta", interfaz_usuario[ key_interfaz ]) === false ? false : component_crear_ruta }
                { encontrarLlaveValorEnEsquema("createdAt", interfaz_usuario[ key_interfaz ]) === false ? false : component_fecha }
                { encontrarLlaveValorEnEsquema("creador", interfaz_usuario[ key_interfaz ]) === false ? false : component_creador }
                { hideActions === true ? false : acciones_botones }
                
            </Table>
        </div>
    }

    const handleSubmit = (e) => {
        if(e) e.preventDefault()
        if (!campoBusqueda){
            setCondicionBusqueda(condicion_default);
            setPagina(1);
            return obtenerRegistros(1, condicion_default);
        }
        const condicion = {
            ...condicion_default,
          $text: { $search: campoBusqueda.toLowerCase() }
        };
        setCondicionBusqueda(condicion);
        setPagina(1);
        return obtenerRegistros(1, condicion);
      };

    const handleChangeCampo = (e) => {
        const { value } = e.target;
        return setCampoBusqueda(value);
      };

    const buscador = () => {
        if(hideSearch === true) return false
        return <Col span="auto"><Form onSubmitCapture={handleSubmit}>
                    <Row gutter={15}>
                        <Col md={14}>
                            <Form.Item label="Buscar">
                                <Input allowClear defaultValue={campoBusqueda} onChange={handleChangeCampo} placeholder={`Buscar por palabras clave`} />
                            </Form.Item>
                        </Col>
                        <Col md={10}>
                            <Form.Item>
                                <Button onClick={handleSubmit} style={{ width: "100%"}}><SearchOutlined /> BUSCAR</Button>
                            </Form.Item>
                        </Col>
                    </Row>
            </Form>
        </Col>
      }

      const agregarFiltroFecha = (key, value) => {
        setFiltroBusqueda(prev => {
            let actual = {...prev}
            if(value){
                actual[key] = DateTime.fromISO(value).toUTC().toISO()
            } else {
                delete actual[key]
            }
            return actual
        })
      }

      const agregarFiltro = (key, value) => {
        let previas = []
        let values = []
        if(key === "ids_origin._id"){
            
            previas = filtroBusqueda[key] ? filtroBusqueda[key] : []
            values = [...previas, ...value.map(v => v._id) ]
            setFiltroBusquedaMetaData(prev => {
                let actual = {...prev}
                if(!actual[key]) actual[key] = []
                actual[key] = [ ...actual[key], ...value ]
                return actual
            })

        } else if( key === "ids_destination._id" ){
            
            previas = filtroBusqueda[key] ? filtroBusqueda[key] : []
            values = [...previas, ...value.map(v => v._id) ]

            setFiltroBusquedaMetaData(prev => {
                let actual = {...prev}
                if(!actual[key]) actual[key] = []
                actual[key] = [ ...actual[key], ...value ]
                return actual
            })

        } else if( key === "ids_vehiculos"){
            previas = filtroBusqueda[key] ? filtroBusqueda[key] : []
            values = [...previas, ...value.map(v => v._id) ]

            setFiltroBusquedaMetaData(prev => {
                let actual = {...prev}
                if(!actual[key]) actual[key] = []
                actual[key] = [ ...actual[key], ...value ]
                return actual
            })
        } else {
            values = { $in: value.map(v => v._id) }
        }
        setFiltroBusqueda(prev => {
            let actual = {...prev}
            actual[key] = values
            return actual
        })
      }

      const refrescarBusqueda = () => {
        setPagina(1)
        let cond = {}
        Object.keys(filtroBusqueda).map(llave => {
            if(filtroBusqueda[llave]['$in']){
                if(Array.isArray(filtroBusqueda[llave]['$in']) !== false){
                    if(filtroBusqueda[llave]['$in'].length > 0) cond[llave] = filtroBusqueda[llave]
                }
            } else if(Array.isArray(filtroBusqueda[llave]) !== false){
                if(filtroBusqueda[llave].length > 0){
                    cond[llave] = { $in: filtroBusqueda[llave] }
                }
            } else {
                cond[llave] = filtroBusqueda[llave]
            }
        })
        obtenerRegistros(1, cond)
    }

    const removerFiltro = (key, value) => {
        setFiltroBusqueda(prev => {
            let actual  = {...prev}
            actual[key] = actual[key].filter(id => id !== value)
            if( actual[key] ) if(actual[key].length < 1) delete actual[key]
            return actual
        })
        setFiltroBusquedaMetaData(prev => {
            let actual  = {...prev}
            actual[key] = actual[key].filter(v => v._id !== value)
            return actual
        })
    }
    
    const removerZonas = (key) => {
        setFiltroBusqueda(prev => {
            let actual  = {...prev}
            delete actual[key]
            return actual
        })
        setFiltroBusquedaMetaData(prev => {
            let actual  = {...prev}
            actual[key] = []
            return actual
        })
    }

    const resetFilters = () => {
        setFiltroBusquedaMetaData({})
        setFiltroBusqueda({})
        setKeyInputFilter(key_input_filter + 1)
        obtenerRegistros(1, condicion_default ? condicion_default : {})
    }
    
      const mostrarDatosPersonalizados = () => {
        const component = <GraficosCamposPersonalizados typeView="modaxl" tipo="contacto" />
        return showCustomFieldsData === true ? <Col><ModalPersonalizado typeView="modal" slug="informe_personalizado" component={component} /></Col> : false
      }

      const mostrarFiltrosBusqueda = () => {

        const mostrarButtonReset = Object.keys(filtroBusqueda).length > 0 ? true : false

        return <div style={{ marginBottom: 20 }} className="mt-0">
            <Row gutter={10}>
                {/* <Col md={6}>
                    <div className="mt-2"><SelectorClientes key={key_input_filter} titulo="Cliente" condicion={{ }} onChange={(data) => agregarFiltro('id_cliente', [{ _id: data.value }])} /></div>
                </Col>
                 
                <Col md={6}>
                    <Title className="mb-2 mt-0" level={5}>Localidad de carga</Title>
                    <SelectorZonaAvanzadoInternacional titleLabel="AGREGAR LOCALIDAD CARGA" onSelected={(data) => agregarFiltro('ids_origin._id', [data])} />
                    
                </Col>
                <Col md={6}>
                    <Title className="mb-2 mt-0" level={5}>Localidad de descarga</Title>
                    <SelectorZonaAvanzadoInternacional titleLabel="AGREGAR LOCALIDAD DESCARGA" onSelected={(data) => agregarFiltro('ids_destination._id', [data])} />
                </Col>
                <Col md={6}>
                    <Title className="mb-2 mt-0" level={5}>Vehículos</Title>
                    <ModalSeleccionVehiculo style={{ width: "100%" }} isMulti={true} showSelection={true} hideSeleccionados={true}  onSelect={data => agregarFiltro('ids_vehiculos', data)} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Tipo de disponibilidad</Title>
                    <Select key={`disponibilidad-${key_input_filter}`} style={{ width: "100%" }} options={tipos_disponibilidad} allowClear onChange={(data) => agregarFiltro("tipo_disponibilidad", data ? [ { _id: data } ] : [])} placeholder="Selecciona" />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Fecha de vencimiento</Title>
                    <Input type="date" key={`vencimiento-${key_input_filter}`} onChange={(e) => agregarFiltroFecha("vencimiento", e.target.value)} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Fecha de carga</Title>
                    <Input type="date" key={`fecha_carga-${key_input_filter}`} onChange={(e) => agregarFiltroFecha("fecha_carga", e.target.value)} />
                </Col>
                <Col md={6}>
                    <Title className="mt-0" level={5}>Fecha de descarga</Title>
                    <Input type="date" key={`fecha_descarga-${key_input_filter}`} onChange={(e) => agregarFiltroFecha("fecha_descarga", e.target.value)} />
                </Col> */}
                <Col md={3}>
                    <Title className="mb-2 mt-0" level={5}>Buscar</Title>
                    <Button onClick={() => refrescarBusqueda()} style={{ width: "100%" }}  >ACTUALIZAR</Button>
                </Col>
                <Col md={3}>
                    <Title className="mb-2 mt-0" level={5}>Limpiar</Title>
                    <Button disabled={!mostrarButtonReset}  style={{ width: "100%" }} onClick={() => resetFilters()}>LIMPIAR</Button>
                </Col>
                <Col xs={24} className="mt-3">
                    <Row gutter={15}>
                    {mostrarMetaDataFiltros('ids_origin._id',  'Zona de carga')}
                    {mostrarMetaDataFiltros('ids_destination._id',  'Zona de descarga')}
                    {mostrarMetaDataFiltros('ids_vehiculos',  'Vehículos')}
                    </Row>
                </Col>
            </Row>
            
        </div>
      }

      const mostrarMetaDataFiltros = (key, title) => {
        if(!filtroBusquedaMetaData[key]) return false
        if(!["ids_origin._id","ids_destination._id","ids_vehiculos"].includes(key) ) return false

            if(filtroBusquedaMetaData[key].length < 1) return false
            return <Col md={8} className="mb-3">
                <Title level={5} className="mt-0 mb-0">{title}</Title>
                {
                    filtroBusquedaMetaData[key].map((e, i) => <Tag color="geekblue" style={{ marginRight: 10 }} className="mt-0 mb-0" key={`${e._id}.${i}`}>{e.titulo}  <IoCloseSharp className="hover" onClick={() => removerFiltro(key, e._id)} /></Tag> )
                }
                <Button size="small" style={{ color: "red" }} type="link" icon={<FaRegTrashAlt />} onClick={() => removerZonas(key)} >REMOVER TODO</Button>
            </Col>
        
      }

      const encabezado = () => {
        return <div>
            <Row gutter={15}>
            {/* {buscador()} */}
            { hideColumns === true ? false : <Col span="auto"><PersonalizarColumnas key_interfaz={key_interfaz} key_esquema={key_esquema} /></Col> }
            {/* { hideExcelButton === true ? false : <Col span="auto"><Button loading={loadingExcel} style={{ marginRight: 10, marginBottom: 15 }} color="green"  onClick={() => descargarExcel()}><FileExcelFilled /> EXPORTAR</Button></Col> } */}
        </Row>
        </div>
      }

      const render = <div>
        {encabezado()}
        <Row gutter={15} className="mb-3">
        </Row>
        {mostrarRegistros()}
      </div>

    return <div>
        {contextHolder}
        {
                showFilters === true ? <Row gutter={15}>
                <Col md={24}>
                    {mostrarFiltrosBusqueda()}
                </Col>
                <Col md={24}>{render}</Col>
            </Row> : <div>{render}</div>
        }
    </div>
}
export default ListadoCanales